import { render, staticRenderFns } from "./productTpye.vue?vue&type=template&id=7bb58286&scoped=true"
import script from "./productTpye.vue?vue&type=script&lang=js"
export * from "./productTpye.vue?vue&type=script&lang=js"
import style0 from "./productTpye.vue?vue&type=style&index=0&id=7bb58286&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb58286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb58286')) {
      api.createRecord('7bb58286', component.options)
    } else {
      api.reload('7bb58286', component.options)
    }
    module.hot.accept("./productTpye.vue?vue&type=template&id=7bb58286&scoped=true", function () {
      api.rerender('7bb58286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/components/productTpye.vue"
export default component.exports